import Contrato from "@/frontend/classes/Contrato";

import { useState, useEffect } from "react";

import { Card, CardBody, Label } from "reactstrap";

//Unform e componentes
import RenderLayoutCampos from "@/frontend/componentes/RenderLayoutCampos";

//Common
import { SITUACAO_CONTRATO } from "@/common/constantes";

//Util
import { ICONES_BOTAO, ICONES_SIIG } from "@/frontend/utils/icones";
import {
  fn_parseLayoutColunas,
  fn_montarCamposContratoPorGrupo,
  fn_getJsxSituacaoContrato,
} from "@/frontend/utils/siig/contrato";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

//Telas
import TSituacao_contrato_hist from "../contrato/situacao_contrato_hist";

/*
 * Tela aba Contrato do detelhamento da solicitação
 */
function TSolicitacao_det_aba_contrato({ solicitacao }) {
  //### USE STATE ###
  const [modalOpenHistSituacao, setModalOpenHistSituacao] = useState(false);

  const [gruposCampos, setGruposCampos] = useState([]);
  const [campos, setCampos] = useState([]);

  const [contrato, setContrato] = useState(null);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega os dados do contrato
    async function loadDadosContrato() {
      const dadosContrato = await api_listar(
        ROTA_LISTAR.SOLICITACAO_CONTRATO,
        `id_solicitacao=${solicitacao.id}`,
      );

      const gruposCampos = fn_montarCamposContratoPorGrupo(dadosContrato);

      setGruposCampos(gruposCampos);
      setCampos(gruposCampos.map((item) => item.campos).flat());
      setContrato(new Contrato(dadosContrato, solicitacao.situacao_contrato));
    }

    loadDadosContrato();
  }, []);

  //### FUNCOES ###
  //Obtém o campo dependente
  function getCampoDep(campoPai) {
    const campoDep = campos.find(
      (campo) => campo.id_campo_contrato_pai == campoPai.id,
    );

    return campoDep;
  }

  //OnClick - Botão Hist. situação
  function handleBotaoHistSituacao() {
    setModalOpenHistSituacao(true);
  }

  return (
    <div className="m-1 mt-3">
      <div className="d-flex align-items-center justify-content-end">
        <Label className="fw-bold mb-0 me-2">Situação: </Label>
        {fn_getJsxSituacaoContrato(solicitacao.situacao_contrato)}

        {solicitacao.situacao_contrato != SITUACAO_CONTRATO.CANCELADO && (
          <div
            className="ms-2 btn-icone"
            title="Consultar histórico"
            onClick={handleBotaoHistSituacao}
          >
            {ICONES_BOTAO.DETALHAR}
          </div>
        )}
      </div>

      {gruposCampos.map((grupo) => {
        const camposGrupo = grupo.campos.filter(
          (campo) => campo.id_campo_contrato_pai == null,
        );

        const layout = fn_parseLayoutColunas(grupo.colunas);

        const conteudo = (
          <RenderLayoutCampos
            campos={camposGrupo}
            layout={layout}
            renderConteudoCampo={(campo) => {
              const campoDep = getCampoDep(campo);

              if (!campoDep) {
                return (
                  <div className="form-group">
                    <Label className="fw-bold">{campo.label}</Label>

                    <div
                      style={
                        campo.tipo_campo == "TXTAREA"
                          ? {
                              maxHeight: "100px",
                              overflowY: "auto",
                              whiteSpace: "pre-wrap",
                              border: "1px solid #dee2e6",
                              borderRadius: "4px",
                              padding: "8px",
                            }
                          : {}
                      }
                    >
                      <span>{campo.descricao_valor || campo.valor}</span>
                    </div>
                  </div>
                );
              }

              //Com campo dep
              return (
                <div className="d-flex gap-2 align-items-end">
                  <div className="form-group">
                    <Label className="fw-bold">{campo.label}</Label>{" "}
                    <div> {campo.descricao_valor || campo.valor}</div>
                  </div>
                  <div className="form-group">
                    <Label className="fw-bold">{campoDep.label}</Label>{" "}
                    <div> {campoDep.descricao_valor || campoDep.valor}</div>
                  </div>
                </div>
              );
            }}
          />
        );

        if (grupo.possui_card == "N") {
          return (
            <div className="m-3" key={grupo.id}>
              {conteudo}
            </div>
          );
        }

        return (
          <Card key={grupo.id} className="mb-4">
            <div className="custom-card-title mb-0">
              {grupo.icone ? (
                <span className="me-2">{ICONES_SIIG[grupo.icone]}</span>
              ) : (
                ""
              )}
              {grupo.nome}
            </div>

            <CardBody>{conteudo}</CardBody>
          </Card>
        );
      })}

      {modalOpenHistSituacao && (
        <TSituacao_contrato_hist
          modalOpen={modalOpenHistSituacao}
          toggleModal={() => setModalOpenHistSituacao(!modalOpenHistSituacao)}
          solicitacao={solicitacao}
        />
      )}
    </div>
  );
}

export default TSolicitacao_det_aba_contrato;
